import React, { useEffect, useState } from "react";
import { getConsent, setConsent, initKlaviyo, onOpenCookieSettings, KLAVIYO_ENABLED } from "../utils/klaviyo";

/**
 * CookieConsent — asks before Klaviyo's tracking cookie is set (UK PECR). The basket, sign-in and
 * offer flags are strictly necessary or set at the shopper's request, so they don't need consent.
 * Accept and Reject are equally prominent, as the ICO expects.
 */
export default function CookieConsent() {
  const [isOpen, setIsOpen] = useState(() => KLAVIYO_ENABLED && getConsent() === "");

  // A returning visitor who already accepted starts tracking straight away
  useEffect(() => {
    initKlaviyo();
  }, []);

  useEffect(() => onOpenCookieSettings(() => setIsOpen(true)), []);

  if (!KLAVIYO_ENABLED || !isOpen) return null;

  const choose = (value) => {
    setConsent(value);
    setIsOpen(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie choices"
      className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-cream/15 bg-[#082D33] p-5 text-cream shadow-2xl"
      data-testid="cookie-consent"
    >
      <p className="text-sm leading-relaxed text-cream/85">
        We use essential cookies to keep your basket and sign-in working. With your permission we'd also use
        Klaviyo cookies to remember you and email a reminder if you leave items in your basket.
      </p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row">
        <button
          type="button"
          onClick={() => choose("accepted")}
          className="flex-1 rounded-full bg-[#F6A81E] px-5 py-3 text-sm font-bold uppercase tracking-wider text-[#1D2528] hover:bg-[#f7b43b] transition-colors"
          data-testid="cookie-accept"
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => choose("rejected")}
          className="flex-1 rounded-full bg-[#F6A81E] px-5 py-3 text-sm font-bold uppercase tracking-wider text-[#1D2528] hover:bg-[#f7b43b] transition-colors"
          data-testid="cookie-reject"
        >
          Reject
        </button>
      </div>
    </div>
  );
}
